import { ModelLoadSystem } from '../WebCad3dModelLoadSystem';
import * as marietta from '../../..';
import { Option3D, optWizardMode } from './Option3DInterface';

export class Mode3DTool {

  static option: Option3D = null;

  constructor() {}

  public setOption(option: Option3D) {
    Mode3DTool.option = option;
  }

  public start() {
    // 3D対応していなければ、遷移しない
    if (!marietta.webcad.WebCADGlobal.capableWebGL()) {
      marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_3D_COMPATIBILITY'));
      return;
    }
    marietta.webcad.WebCADGlobal.dimensionMenu.settingRoof();

    // アイテムコントローラーをなくす
    marietta.webcad.WebCADGlobal.itemManager.deleteUnplacedItems();
    marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
    marietta.webcad.WebCADGlobal.itemManager.currentItemGroup = null;

    // 自動廊下生成
    marietta.webcad.WebCADGlobal.cadAPIManager.checkAutoHallways(
      () => {
        // ビジーフィルタ
        marietta.webcad.WebCADGlobal.showBusy();
        // 離れた部屋があるか否かチェック。あれば遷移しない
        marietta.webcad.WebCADGlobal.cadAPIManager.apiHasSeperatedRoom(Mode3DTool.onCheckRoomApartDone);
      }
    );
  }

  /**
   * 離れた部屋があるか否かのチェック
   */
  static onCheckRoomApartDone = (result: boolean) => {
      // ビジーフィルタ
      marietta.webcad.WebCADGlobal.hideBusy();

      if (result) {
        // 隣接していない部屋があります。 <br>間取りを修正してください。
        marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_HAS_SEPERATED_ROOM'), marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
        return;
      }
      marietta.webcad.WebCADGlobal.showBusy();

      // オンラインチェックをしてから、自動廊下生成
      marietta.webcad.WebCADGlobal.checkOnlineAnd(Mode3DTool.oncheckAutoHallwaysDoneCheckAutoFittings);
  }

  static oncheckAutoHallwaysDoneCheckAutoFittings = () => {
    marietta.webcad.WebCADGlobal.hideBusy();

    if ((<optWizardMode>Mode3DTool.option)?.isWizardMode) {
      Mode3DTool.checkModelParam();
      return;
    }

    clearTimeout(marietta.webcad.WebCADGlobal.dimensionMenu.restrictChangeMode3DEvent);
    marietta.webcad.WebCADGlobal.dimensionMenu.restrictChangeMode3DEvent = setTimeout(() => {
      marietta.webcad.WebCADGlobal.showBusy(marietta.webcad.collection.WebCADMessages.getText('BUSY_PREPARING_DATA'), () => {
        // ビジー表示完了後、アイテム数確認
        console.log('checkItemSize');
        marietta.webcad.WebCADGlobal.dimensionMenu.checkItemSize(Mode3DTool.onCheckItemSizeDoneCreateMiniMap);
      });
    }, 0);
  }

  /**
   * アイテム個数の確認後、ミニマップの作成へ
   */
  static onCheckItemSizeDoneCreateMiniMap = () => {
    setTimeout(() => {
      // ミニマップの作成
      marietta.webcad.WebCADGlobal.miniMapManager.createMiniMap(Mode3DTool.checkModelParam);
    }, 0);
  }

  /**
   * 3Dスタイル設定の判別
   */
  static checkModelParam = () => {
    marietta.webcad.WebCADGlobal.dimensionMenu.styleFixed();

    // 3D表示
    const modelLoadSystem = new ModelLoadSystem();
    modelLoadSystem.setOption(Mode3DTool.option);
    modelLoadSystem.request3D();
  }

}